const angular = require('angular');
const app = angular.module('learn-resources');
/**
 * Files Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Presentations', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {
  
  return $resource(appConfiguration.apiUrl + '/learn/v3/presentations/:subresource/:action/:slideresource', null, {
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    update: {params: {subresource: ''}, method: 'POST', isArray: false},
    addSlide: {params: {subresource: '', action: 'add-slide'}, method: 'POST', isArray: false},
    editSlideContent: {params: {subresource: '', action: 'edit-slide-content'}, method: 'POST', isArray: false},
    editSlideTitle: {params: {subresource: '', action: 'edit-slide-title'}, method: 'POST', isArray: false},
    editSlideOrder: {params: {subresource: '', action: 'edit-slide-order'}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false},
    removeMultiple: {params: {subresource: 'remove-multiple'}, method: 'POST', isArray: false},
    removeSlide: {params: {subresource: '', action: 'remove-slide'}, method: 'DELETE', isArray: false}
  });

}]);
